import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextBlock = /** @class */ (function (_super) {
    __extends(TextBlock, _super);
    function TextBlock(content, tabStops, textJustifier, lineRotation, baselineZero, bidiLevel, applyNonLinearFontScaling, baselineFontDescription, baselineFontSize) {
        if (content === void 0) { content = null; }
        if (tabStops === void 0) { tabStops = null; }
        if (textJustifier === void 0) { textJustifier = null; }
        if (lineRotation === void 0) { lineRotation = 'rotate0'; }
        if (baselineZero === void 0) { baselineZero = 'roman'; }
        if (bidiLevel === void 0) { bidiLevel = 0; }
        if (applyNonLinearFontScaling === void 0) { applyNonLinearFontScaling = true; }
        if (baselineFontDescription === void 0) { baselineFontDescription = null; }
        if (baselineFontSize === void 0) { baselineFontSize = 12; }
        var _this = _super.call(this) || this;
        _this._content = content;
        _this._tabStops = tabStops;
        _this._textJustifier = textJustifier;
        _this._lineRotation = lineRotation;
        _this._baselineZero = baselineZero;
        _this._bidiLevel = bidiLevel;
        _this._applyNonLinearFontScaling = applyNonLinearFontScaling;
        _this._baselineFontDescription = baselineFontDescription;
        _this._baselineFontSize = baselineFontSize;
        _this._textLines = [];
        return _this;
    }
    TextBlock.prototype.createTextLine = function (previousLine, width, lineOffset, fitSomething) {
        //console.warn('[TextBlock] - createTextLine not implemented', this._content, this._textJustifier);
        var newTextLine = new this.sec.flash.text.engine.TextLine(previousLine, width, lineOffset, fitSomething, this._content.text, this._content._elementFormat);
        newTextLine.setTextBlock(this);
        this._textLines.push(newTextLine);
        return newTextLine;
    };
    TextBlock.prototype.recreateTextLine = function (textLine, previousLine, width, lineOffset, fitSomething) {
        console.warn('[TextBlock] - recreateTextLine not implemented');
        return new this.sec.flash.text.engine.TextLine();
    };
    Object.defineProperty(TextBlock.prototype, "applyNonLinearFontScaling", {
        get: function () {
            //console.warn('[TextBlock] - get applyNonLinearFontScaling not implemented');
            return this._applyNonLinearFontScaling;
        },
        set: function (value) {
            //console.warn('[TextBlock] - set applyNonLinearFontScaling not implemented');
            this._applyNonLinearFontScaling = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "baselineFontDescription", {
        get: function () {
            //console.warn('[TextBlock] - get baselineFontDescription not implemented');
            return this._baselineFontDescription;
        },
        set: function (value) {
            //console.warn('[TextBlock] - set baselineFontDescription not implemented');
            this._baselineFontDescription = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "baselineFontSize", {
        get: function () {
            //console.warn('[TextBlock] - get baselineFontSize not implemented');
            return this._baselineFontSize;
        },
        set: function (value) {
            //console.warn('[TextBlock] - set baselineFontSize not implemented');
            this._baselineFontSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "baselineZero", {
        get: function () {
            //console.warn('[TextBlock] - get baselineZero not implemented');
            return this._baselineZero;
        },
        set: function (value) {
            //console.warn('[TextBlock] - set baselineZero not implemented');
            this._baselineZero = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "content", {
        get: function () {
            //console.warn('[TextBlock] - get content not implemented');
            return this._content;
        },
        set: function (value) {
            //console.warn('[TextBlock] - set content not implemented');
            this._content = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "bidiLevel", {
        get: function () {
            //console.warn('[TextBlock] - get bidiLevel not implemented');
            return this._bidiLevel;
        },
        set: function (value /*int*/) {
            //console.warn('[TextBlock] - set bidiLevel not implemented');
            this._bidiLevel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "firstInvalidLine", {
        get: function () {
            //console.warn('[TextBlock] - get firstInvalidLine not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "firstLine", {
        get: function () {
            //console.warn('[TextBlock] - get firstLine not implemented');
            return null; //this._textLines.length > 0 ? this._textLines[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "lastLine", {
        get: function () {
            //console.warn('[TextBlock] - get lastLine not implemented');
            return null; //this._textLines.length > 0 ? this._textLines[this._textLines.length - 1] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "textLineCreationResult", {
        get: function () {
            console.warn('[TextBlock] - get textLineCreationResult not implemented');
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBlock.prototype, "lineRotation", {
        get: function () {
            return this._lineRotation;
        },
        set: function (value) {
            this._lineRotation = value;
        },
        enumerable: true,
        configurable: true
    });
    TextBlock.prototype.findNextAtomBoundary = function (afterCharIndex /*int*/) {
        console.warn('[TextBlock] - findNextAtomBoundary not implemented');
        return null;
    };
    TextBlock.prototype.findPreviousAtomBoundary = function (beforeCharIndex /*int*/) {
        console.warn('[TextBlock] - findPreviousAtomBoundary not implemented');
        return null;
    };
    TextBlock.prototype.findNextWordBoundary = function (afterCharIndex /*int*/) {
        console.warn('[TextBlock] - findNextWordBoundary not implemented');
        return null;
    };
    TextBlock.prototype.findPreviousWordBoundary = function (beforeCharIndex /*int*/) {
        console.warn('[TextBlock] - findPreviousWordBoundary not implemented');
        return null;
    };
    TextBlock.prototype.getTextLineAtCharIndex = function (charIndex /*int*/) {
        console.warn('[TextBlock] - getTextLineAtCharIndex not implemented');
        return null;
    };
    TextBlock.prototype.releaseLineCreationData = function () {
        console.warn('[TextBlock] - releaseLineCreationData not implemented');
    };
    TextBlock.prototype.releaseLines = function (firstLine, lastLine) {
        //console.warn('[TextBlock] - releaseLines not implemented');
        this._textLines.length = 0;
    };
    TextBlock.prototype.dump = function () {
        console.warn('[TextBlock] - dump not implemented');
        return null;
    };
    TextBlock.prototype.DoCreateTextLine = function (previousLine, width, lineOffset, fitSomething, reuseLine) {
        if (lineOffset === void 0) { lineOffset = 0; }
        if (fitSomething === void 0) { fitSomething = false; }
        if (reuseLine === void 0) { reuseLine = null; }
        console.warn('[TextBlock] - DoCreateTextLine not implemented');
        return null;
    };
    TextBlock.prototype.getTabStops = function () {
        return this._tabStops;
    };
    TextBlock.prototype.setTabStops = function (value /*ASVector<flash.text.engine.TabStop>*/) {
        this._tabStops = value;
    };
    TextBlock.prototype.getTextJustifier = function () {
        return this._textJustifier;
    };
    TextBlock.prototype.setTextJustifier = function (value) {
        this._textJustifier = value;
    };
    Object.defineProperty(TextBlock.prototype, "userData", {
        get: function () {
            return this._userData;
        },
        set: function (value) {
            this._userData = value;
        },
        enumerable: true,
        configurable: true
    });
    TextBlock.forceNativeConstructor = true;
    TextBlock.forceNativeMethods = true;
    return TextBlock;
}(ASObject));
export { TextBlock };
